import {Injectable} from '@angular/core';
import {Stage} from '../../../../../types/stage';
import { SERVER_API_URL_NEW } from '../../../../../types/app.constants';
import { ApiDataService } from 'src/app/api/services/api-data.service';
import { Observable } from 'rxjs';
import { CecTable } from 'src/app/common/types/cec-table';

@Injectable({
  providedIn: 'root'
})
export class StageCardService {

  constructor(private service: ApiDataService) {}

  /**
   * function for saving edited stage
   */
  create(stage: Stage): Observable<boolean> {
    return this.service.post<boolean>('stages', stage);
  }

  /**
   * function for saving edited stage
   */
  update(stage: Stage): Observable<boolean> {
    return this.service.put<boolean>('stages', stage);
  }

  get(id: number): Observable<Stage> {
    return this.service.get<Stage>('stages/' + id);
  }

  getCorrectReport(id: number): Observable<CecTable[]> {
    return this.service.getAll<CecTable>('stages/correct-report/' + id);
  }

  getTime(id: number): Observable<number> {
    return this.service.get<number>('stages/get-time/' + id);
  }

  getName(id: number): Observable<string> {
    return this.service.get<string>('stages/get-name/' + id);
  }

  public getDisplayReportsStatus(id: number): Observable<boolean> {
    return this.service.get<boolean>('stages/get-reports-status/' + id);
  }

  public updateReportsStatus(id: number): Observable<void> {
    return this.service.patchEmpty<void>('stages/update-reports-status/' + id);
  }

  public getDisplayResultsStatus(id: number): Observable<boolean> {
    return this.service.get<boolean>('stages/get-results-status/' + id);
  }

  public updateResultsStatus(id: number): Observable<void> {
    return this.service.patchEmpty<void>('stages/update-results-status/' + id);
  }

  /** @inheritdoc */
  public delete(id: number): Observable<boolean> {
    return this.service.delete<boolean>('stages', id);
  }

}
